/** @format */

import { Box, Container, Grid, styled, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Footer, SEO } from "../allComponents/AllComponents";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import SecurityIcon from "@mui/icons-material/Security";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PeopleIcon from "@mui/icons-material/People";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

const PageContainer = styled(Container)(({ theme }) => ({
	paddingTop: theme.spacing(8),
	paddingBottom: theme.spacing(8),
	fontFamily: "'Inter', sans-serif",
}));

const FeatureBox = styled(Box)(({ theme }) => ({
	textAlign: "center",
	padding: theme.spacing(3),
}));

const Features = () => {
	const { t } = useTranslation("pages");

	const featuresList = t("features.features", { returnObjects: true }) as Array<{
		title: string;
		description: string;
		icon: string;
	}>;

	return (
		<React.Fragment>
			<SEO
				title={t("features.title")}
				description={t("features.subtitle")}
				keywords="savings circle features, automated contributions, secure payments, contribution tracking, community savings tools, group finance features"
				url="/features"
			/>
			<PageContainer maxWidth="lg">
				<Typography
					variant="h3"
					gutterBottom
					sx={{
						fontFamily: "'Montserrat', sans-serif",
						fontWeight: 600,
						mb: 4,
					}}>
					{t("features.title")}
				</Typography>
				<Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
					{t("features.subtitle")}
				</Typography>
				<Grid container spacing={4}>
					{featuresList && featuresList.length > 0 ?
						featuresList.map((feature, index) => (
							<Grid item xs={12} sm={6} md={4} key={index}>
								<FeatureBox>
									{index % 5 === 0 && <CheckCircleOutlineIcon color="primary" sx={{ fontSize: 50 }} />}
									{index % 5 === 1 && <ScheduleIcon color="primary" sx={{ fontSize: 50 }} />}
									{index % 5 === 2 && <SecurityIcon color="primary" sx={{ fontSize: 50 }} />}
									{index % 5 === 3 && <PeopleIcon color="primary" sx={{ fontSize: 50 }} />}
									{index % 5 === 4 && <TrendingUpIcon color="primary" sx={{ fontSize: 50 }} />}
									<Typography variant="h6" sx={{ mt: 2, fontWeight: 500 }}>
										{feature.title}
									</Typography>
									<Typography variant="body1" sx={{ mt: 1 }}>
										{feature.description}
									</Typography>
								</FeatureBox>
							</Grid>
						))
						: (
							<Grid item xs={12}>
								<Typography variant="body1" color="text.secondary">
									No features available
								</Typography>
							</Grid>
						)}
				</Grid>
			</PageContainer>
			<Footer />
		</React.Fragment>
	);
};

export default Features;
